module.exports = __webpack_public_path__ + "static/media/IMG_9840.dc2d543e.jpg";